//
// Splide Config
// --------------------------------------------------
// Checks page for panels utilising splide and initialises their splide sliders with configurations set here

window.addEventListener('load', () => {
    let availableCarousels = document.querySelectorAll('.splide');
    let instagramSplidePanel = document.querySelectorAll('.instagram-panel')
    let mediaSplidePanel = document.querySelectorAll('.media-panel');
    let testimonialsSplidePanel = document.querySelectorAll('.testimonials-panel');
    let cardsSplidePanel = document.querySelectorAll('.card-panel-slider');

    if (availableCarousels.length) {

        // START MEDIA PANEL SLIDER
        for ( let panel of mediaSplidePanel ) {
            let parentPanel = panel.closest('.media-panel');
            let totalSlides = parentPanel.querySelector('.media-splide').dataset.totalSlides;
            let currentPostCounter = parentPanel.querySelector('[data-splide="counter"]');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            let mediaSplide = new Splide(panel.querySelector('.media-splide'), {
                type: 'fade',
                speed: 750,
                arrows: false,
                autoplay: false,
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        mediaSplide.go('+1');
                    }
                    else {
                        mediaSplide.go('-1');
                    }
                });
            }

            mediaSplide.on('mounted move', function () {
                if (currentPostCounter) {
                    const updateIndex = setTimeout(() => {
                        currentPostCounter.textContent = (mediaSplide.index + 1);

                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (mediaSplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }

                            if (arrow.dataset.navigate == '-' && (mediaSplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }
                        }
                    }, 50);
                }
            });

            mediaSplide.mount()
        }
        // END MEDIA PANEL SLIDER

        // START TESTIMONIAL PANEL SLIDER
        for ( let panel of testimonialsSplidePanel ) {
            let parentPanel = panel.closest('.testimonials-panel');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');
            let slideCount = parentPanel.querySelector('.testimonials-splide').dataset.totalSlides;
            let progressBar = parentPanel.querySelector('.progress-bar');

            let testimonialsSplide = new Splide(panel.querySelector('.testimonials-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: false,
                gap: '2.5rem',
                perPage: 3,
                pagination: false,
                autoplay: false,
                padding: '2rem',
                interval: 10000,
                classes: {
                    pagination: 'splide__pagination w-full flex justify-center items-center gap-2 mt-12',
                    page      : 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 bg-blue hover:brightness-110 [&.is-active]:!bg-orange transition-all duration-150 ease-in-out'
                },
                breakpoints: {
                    1024: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                    },
                    768: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                    },
                },
            });

            testimonialsSplide.on('mounted move', function () {

                let slideModifier = 3;

                const smToLgMediaQuery = window.matchMedia('(max-width: 1023px)');
                const smMediaQuery = window.matchMedia('(max-width: 767px)');

                if (smToLgMediaQuery.matches) {
                    slideModifier = 2;
                }

                if (smMediaQuery.matches) {
                    slideModifier = 1;
                }

                let end = testimonialsSplide.Components.Controller.getEnd() + slideModifier;


                progressBar.style.width = String(100 * (testimonialsSplide.index + 1) / end) + '%';
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        testimonialsSplide.go('+1');
                        arrow.dataset.transition = 'true';
                        setTimeout(function () {
                            arrow.dataset.transition = 'false';
                        }, 150);
                    }
                    else {
                        testimonialsSplide.go('-1');
                        arrow.dataset.transition = 'true';
                        setTimeout(function () {
                            arrow.dataset.transition = 'false';
                        }, 150);
                    }
                });
            }

            testimonialsSplide.mount();
        }
        // END TESTIMONIAL PANEL SLIDER


        // START CARDS PANEL SLIDER
        for ( let panel of cardsSplidePanel ) {
            let parentPanel = panel.closest('.card-panel-slider');
            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            let cardsSplide = new Splide(panel.querySelector('.cards-splide'), {
                type: 'loop',
                speed: 750,
                direction: 'ltr',
                pauseOnHover: true,
                arrows: false,
                gap: '2.5rem',
                perPage: 3,
                pagination: true,
                autoplay: false,
                padding: '2rem',
                interval: 10000,
                classes: {
                    pagination: 'splide__pagination w-full flex justify-center items-center gap-2 mt-12',
                    page      : 'splide__pagination__page rounded-full overflow-hidden w-3 h-3 bg-gray-100/25 hover:brightness-125 [&.is-active]:!bg-green transition-all duration-150 ease-in-out'
                },
                breakpoints: {
                    1024: {
                        perPage: 2,
                        padding: '1.5rem',
                        gap: '1.5rem',
                    },
                    768: {
                        perPage: 1,
                        padding: '1.5rem',
                        gap: '1.5rem',
                    },
                },
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        cardsSplide.go('+1');
                        arrow.dataset.transition = 'true';
                        setTimeout(function () {
                            arrow.dataset.transition = 'false';
                        }, 150);
                    }
                    else {
                        cardsSplide.go('-1');
                        arrow.dataset.transition = 'true';
                        setTimeout(function () {
                            arrow.dataset.transition = 'false';
                        }, 150);
                    }
                });
            }

            cardsSplide.mount();
        }
        // END CARDS PANEL SLIDER

        // START INSTAGRAM PANEL SLIDER
        for ( let panel of instagramSplidePanel ) {
            let parentPanel = panel.closest('.instagram-panel');
            let defaultProgressBar = parentPanel.querySelector('[data-progress-bar="default"]');
            let instagramThumbnails = parentPanel.querySelectorAll('[data-instagram-image]');
            let lightbox = parentPanel.querySelector('[data-instagram-lightbox]');
            let lightboxClose = (lightbox ? lightbox.querySelectorAll('[data-close-lightbox]') : null);
            let lightBoxProgressBar = (lightbox ? lightbox.querySelector('[data-progress-bar="lightbox"]') : null);

            let currentPostCounter = parentPanel.querySelector('.instagram-splide-current-slide');

            let navArrows = parentPanel.querySelectorAll('.splide-nav-arrow');

            let totalSlides = parentPanel.querySelector('.instagram-splide').dataset.totalSlides;


            let instagramSplide = new Splide(panel.querySelector('.instagram-splide'), {
                type: 'slide',
                speed: 750,
                perPage: 4,
                gap: '2rem',
                perMove: 1,
                arrows: false,
                padding: { left: '2rem', right: '2rem' },
                breakpoints: {
                    1024: {
                        perPage: 3,
                        padding: { left: '2rem', right: '2rem' },
                        gap: '2rem'
                    },
                    640: {
                        perPage: 2,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                    480: {
                        perPage: 1,
                        padding: { left: '1.5rem', right: '1.5rem' },
                    },
                },
            });

            let instagramLightbox = new Splide(panel.querySelector('.instagram-lightbox-splide'), {
                type: 'fade',
                speed: 750,
                classes: {
                    arrows: 'splide__arrows absolute w-full h-full items-center justify-between flex',
                    arrow: 'splide__arrow relative z-5 rounded-l-lg bg-green bg-opacity-20 md:bg-transparent p-0 w-10 h-12 fill-current text-white disabled:text-opacity-20 transition-all duration-300 flex items-center justify-center hover:scale-110 disabled:!scale-100',
                    prev: 'splide__arrow--prev left-0 2xl:-left-16 rotate-180',
                    next: 'splide__arrow--next right-0 2xl:-right-16',
                },
            });

            for ( let arrow of navArrows ) {
                arrow.addEventListener('click', () => {
                    if (arrow.dataset.navigate == '+') {
                        instagramSplide.go('+1');
                        arrow.dataset.transition = 'true';
                        setTimeout(function () {
                            arrow.dataset.transition = 'false';
                        }, 150);
                    }
                    else {
                        instagramSplide.go('-1');
                        arrow.dataset.transition = 'true';
                        setTimeout(function () {
                            arrow.dataset.transition = 'false';
                        }, 150);
                    }
                });
            }

            function closeLightBox() {
                lightbox.classList.add('opacity-0');
                lightbox.classList.add('pointer-events-none');
                const lightboxHide = setTimeout(() => {
                    lightbox.classList.add('hidden');
                }, 300);
            }

            function openLightBox() {
                lightbox.classList.remove('hidden');
                const lightboxShow = setTimeout(() => {
                    lightbox.classList.remove('opacity-0');
                    lightbox.classList.remove('pointer-events-none');
                }, 50);
            }

            for ( let thumbnail of instagramThumbnails ) {
                thumbnail.addEventListener('click', () => {
                    if (thumbnail.dataset.slide.length) {
                        instagramLightbox.go(parseInt(thumbnail.dataset.slide));
                    }
                    openLightBox();
                });
            }

            if (lightbox) {
                // Closes lightbox on backdrop/close button press

                document.addEventListener("keydown", (e) => {
                    if (!lightbox.classList.contains('hidden')) {
                        if (e.key === "Escape") {
                            closeLightBox();
                        }
                        else if (e.key === "ArrowRight") {
                            instagramLightbox.go('+1');
                        }
                        else if (e.key === "ArrowLeft") {
                            instagramLightbox.go('-1');
                        }
                    }
                });

                instagramLightbox.on('mounted move', function () {
                    let end = instagramLightbox.Components.Controller.getEnd() + 1;
                    lightBoxProgressBar.style.width = String(100 * (instagramLightbox.index + 1) / end) + '%';
                });

                for (let close of lightboxClose) {
                    close.addEventListener('click', () => {
                        closeLightBox();
                    });
                }
            }

            instagramSplide.on('mounted move', function () {
                if (currentPostCounter) {
                    const updateIndex = setTimeout(() => {
                        currentPostCounter.textContent = (instagramSplide.index + 1).toString();
                        for ( let arrow of navArrows ) {
                            if (arrow.dataset.navigate == '+' && (instagramSplide.index + 1) == totalSlides) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '+') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }

                            if (arrow.dataset.navigate == '-' && (instagramSplide.index + 1) == 1) {
                                arrow.classList.add('!opacity-20', 'pointer-events-none');
                            }
                            else if (arrow.dataset.navigate == '-') {
                                arrow.classList.remove('!opacity-20', 'pointer-events-none');
                            }
                        }
                    }, 50);
                }

                let end = instagramSplide.Components.Controller.getEnd() + 1;

                defaultProgressBar.style.width = String(100 * (instagramSplide.index + 1) / end) + '%';

            });

            instagramSplide.sync(instagramLightbox);
            instagramSplide.mount();
            instagramLightbox.mount();
        }
        // END INSTAGRAM PANEL SLIDER
    }
});
